import React, { Component } from 'react';
import { ApiClient } from '../../libs/apiClient';
import { SearchPartnerRefSys } from '../index';
import $ from 'jquery';

const apiClient = ApiClient.getInstance();


class SendReferralPartner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AmbassadorCode: '',
            enableSearchPartner: false
        }
    }

    componentDidMount() {
        this.closeAction();
    }

    closeModal = async () => {
        $('#sendReferralPartner').modal('hide');
    };

    closeAction = () => {
        $('#sendReferralPartner').on('hide.bs.modal', function () {

        });
    };


    GetSelectedPartnerFather = (object) => {
        const { ReceiveFather } = this.props
        ReceiveFather(object)
    }

    ChangeFieldPartner = async (value) => {
        await this.setState({
            fieldSearch: value
        })
        this.GetPartnersData();
    }

    OpenModalPartner = async () => {
        await this.setState({
            enableSearchPartner: true
        });
        $('#searchPartnerRefSys').modal('show');
    };


    SearchPartnerCloseAct = async () => {
        await this.setState({
            enableSearchPartner: false
        });
    }

    ReceiveInfoByInfo = async (info) => {
        this.OnChangeRelatedAmbassador(info.CardCode ?? '')
        $('#searchPartnerRefSys').modal('hide');
        await this.setState({
            enableSearchPartner: false
        });
    }

    OnChangeRelatedAmbassador = async (value) => {
        await this.setState({
            AmbassadorCode: value
        })
    }

    SendDataToConvert = async () => {
        const { showAlert } = this.props
        if (this.state.AmbassadorCode === '') {
            showAlert({ type: 'error', message: `Selecciona un embajador para continuar`, timeOut: 3000 });
            return
        }
        this.props.SendDataToConvertProps(this.props.info.CardCode, this.state.AmbassadorCode)
    }

    render() {
        const { info, showAlert, enableSpinner } = this.props
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="sendReferralPartner" role="dialog" aria-labelledby="exampleModalLabel" style={{ zIndex: 1055 }} aria-hidden="true">
                {this.state.enableSearchPartner &&
                    <SearchPartnerRefSys
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        actionLabel={"Seleccionar embajador"}
                        typeSearch={"SearchAmbassadors"}
                        closeAction={this.SearchPartnerCloseAct}
                        ReceiveFather={this.ReceiveInfoByInfo}
                    />
                }
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {`CONVERTIR A CLIENTE REFERIDO ${info !== null ? `A: ${info?.CardName}` : ''}`}
                            </h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="search-div row">
                                <div className="col-md-12" style={{ width: '100%' }}>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold"> Embajador </span>
                                        </div>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={this.state.AmbassadorCode ?? ''}
                                        />

                                        <div className="input-group-prepend">
                                            <button
                                                type="button"
                                                className="btn btn-outline-warning rounded-right"
                                                onClick={this.OpenModalPartner} >
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect" onClick={() => this.SendDataToConvert()}>Enviar datos</button>
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default SendReferralPartner